import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Kontakti.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class Kontakti extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      show_feedback: false
    };
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, assets_path, cardsOnly } = this.props,
    { show_feedback } = this.state

    return (
      <section className={styles.section}>
        <Container>
          {!cardsOnly &&
            <>
              <WhiteBlockTitle
                title={data?.title || ``}
                text={data?.rtext || ``}
              />
              <div className={styles.contakti}>
                <div className={styles.left}>
                  <div className={styles.left_line}>
                    <div className={styles.left_line_content}>
                      <Image src={`/${assets_path}/images/kontakti/phone.svg`} width={14} height={14} />
                      <div>
                        <a className={styles.left_line_title} href={`tel:${data?.phone.replace(/[^\d+]/g, '')}`}>{data?.phone}</a>
                        <div className={styles.left_line_text}>Наш телефон</div>
                      </div>
                    </div>
                    <GreenButton
                      text={`Перезвонить мне`}
                      width={164}
                      action={() => { this.showFeedback() }}
                    />
                    <FeedbackForm
                      title={`Позвонить нам`}
                      text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                      btn={`Отправить`}
                      data={[]}
                      show={show_feedback}
                      handleClose={() => this.closeFeedback()}
                    />
                  </div>
                  <div className={styles.left_line}>
                    <div className={styles.left_line_content}>
                      <Image src={`/${assets_path}/images/kontakti/earth.svg`} width={14} height={14} />
                      <div>
                        <div className={styles.left_line_title} dangerouslySetInnerHTML={{__html: data?.adres}} />
                        <div className={styles.left_line_text}>Наш адрес</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.left_line}>
                    <div className={styles.left_line_content}>
                      <Image src={`/${assets_path}/images/kontakti/sms.svg`} width={14} height={14} />
                      <div>
                        <a className={styles.left_line_title} href={`mailto:${data?.email}`}>{data?.email}</a>
                        <div className={styles.left_line_text}>Наш емайл</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.left_line}>
                    <div className={styles.left_line_content}>
                      <Image src={`/${assets_path}/images/kontakti/radar.svg`} width={14} height={14} />
                      <div>
                        <div className={styles.left_line_title}>
                          {data?.worktime}
                        </div>
                        <div className={styles.left_line_text} dangerouslySetInnerHTML={{__html: data.rezim}} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.map} dangerouslySetInnerHTML={{__html: data.map}} />
              </div>
            </>
          }
          <div className={styles.list}>
            {data?.list.map( ( elm, k ) => (
              <a href={elm?.link} className={styles.list_el}>
                <Image className={styles.list_el_image} src={elm?.image} width={585} height={158} />
                <div className={styles.list_el_content}>
                  <GreenButton
                    text={`Смотреть`}
                    width={106}
                    action={() => {  }}
                  />
                  <div className={styles.list_el_title}>{elm?.name}</div>
                  <div className={styles.list_el_bline}>
                    <div>GOODWIN</div>
                    <div className={styles.list_el_bline_sep} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </Container>
      </section>
    )
  }
}

Kontakti.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  cardsOnly: PropTypes.bool
}

Kontakti.defaultProps = {
  data: {},
  assets_path: ``,
  cardsOnly: false
}

export default Kontakti